// @flow

import _ from 'lodash';

import ko from 'rgs-knockout';

import $ from 'jquery';
import { FileUpload2ViewModel } from 'ko-component-file-upload2/js/model';

require('rgs-jquery-fileupload');

const INSERT_INPUT_HERE_ATTR = 'data-file-upload2-insert-input-here';
const INSERT_INPUT_HERE_CLASS = 'ko-component-file-upload2-input-wrap';
const INSERTED_INPUT_ATTR = 'data-file-upload2-inserted-input';
const INSERTED_INPUT_CLASS = 'ko-component-file-upload2-input';

ko.bindingHandlers['ko-component-file-upload2#jqFileupload'] = {
	init: function (
		element,
		valueAccessor,
		allBindings,
		viewModel: FileUpload2ViewModel,
		bindingContext,
	) {
		ko.applyBindingAccessorsToNode(element, {
			template: function () {
				return {
					nodes: bindingContext.$componentTemplateNodes,
					data: bindingContext.$parent,
				};
			},
		}, bindingContext.extend({ $fileupload: bindingContext.$component._$fileupload() }));

		const options = valueAccessor();

		const $element = $(element);
		const $inputWrap = $('[' + INSERT_INPUT_HERE_ATTR + ']', element);

		const inputProps = {
			class: INSERTED_INPUT_CLASS,
			type: 'file',
			multiple: options.multiple,
			[INSERTED_INPUT_ATTR]: true,
		};

		if (viewModel.inputName) {
			inputProps['name'] = viewModel.inputName();
		}

		const accept = viewModel.accept;

		if (accept.length > 1) {
			inputProps['accept'] = accept;
		}

		const $input = $('<input></input>', inputProps);
		$inputWrap.append($input);
		$inputWrap.toggleClass(INSERT_INPUT_HERE_CLASS, true);

		function getOptions () {
			return _.defaults({
				dropZone: $element,
				pasteZone: $element,
				fileInput: $('[' + INSERTED_INPUT_ATTR + ']', element),
				replaceFileInput: bindingContext.$component.replaceFileInput,
			}, bindingContext.$component._jqFileuploadOptions());
		}

		ko.computed(function () {
			const options = getOptions();

			ko.ignoreDependencies(function () {
				$element.fileupload(options);
			});
		}, null, {
			disposeWhenNodeIsRemoved: element,
		});

		// bind events
		const initialOptions = getOptions();
		_.each(initialOptions.event, (handler, name) => {
			if (name.startsWith('after')) {
				name = name.replace(/^after/, '');
				handler = _.partial(_.defer, handler);
			}
			$element.on('fileupload' + name, handler);
		});

		ko.applyBindingAccessorsToNode($input[0], {
			disable: function () {
				const options = getOptions();
				return options.disabled;
			},
		});

		return { controlsDescendantBindings: true };
	},
};
